var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-container white"
  }, [_c('v-text-field', {
    staticClass: "black--text ml-2",
    attrs: {
      "id": "text-input",
      "name": "text-input",
      "label": _vm.textInputPlaceholder,
      "single-line": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.stopPropagation();
        _vm.postTextMessage($event)
      }
    },
    model: {
      value: (_vm.textInput),
      callback: function($$v) {
        _vm.textInput = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "textInput"
    }
  }), _vm._v(" "), (_vm.isRecorderSupported) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'click to use voice'
      }),
      expression: "{html: 'click to use voice'}",
      arg: "left"
    }],
    staticClass: "black--text mic-button",
    attrs: {
      "icon": "",
      "disabled": _vm.isMicButtonDisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.onMicClick($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v(_vm._s(_vm.micButtonIcon))])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd14e82"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputContainer.vue
// module id = 202
// module chunks = 1